class PurchaseInvoiceLineCell extends InvoiceLineCell
{
    get entityName() : string { return "PurchaseInvoiceLine"; }

    protected productDidSelect(controller:SelectEntityViewController, product:Product, supplierProduct?:SupplierProduct)
    {
        super.productDidSelect(controller, product, supplierProduct);
        
        this.vat = this.taxForProduct(product);
        this.updateTaxUI();
    }

    // The purchase tax of the product (its buy tax, else its tax, else its category's).
    protected taxForProduct(product:Product) : Tax {
        return DBHelper.stockTaxFromProduct(product);
    }
}
